import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { booleanParamSchema } from '../../utils';
import { ZTicketDetails } from './models';

const c = initContract();
export const authDrawOrderContract = c.router(
  {
    calcCost: {
      method: 'GET',
      path: '/calc-cost',
      query: z.object({
        drawTypeCode: z.optional(z.string()),
        excludeCompleted: z.optional(booleanParamSchema),
      }),
      responses: {
        200: z.array(ZTicketDetails),
        404: c.type<{ message: string }>(),
      },
    },

    getPlayerTickets: {
      method: 'GET',
      path: '/tickets/player',
      query: z.object({
        drawTypeCode: z.optional(z.string()),
        drawTypeCodes: z.string().array().optional(),
        drawTypeGroup: z.optional(z.string()),
        excludeDrawTypeCodes: z.optional(z.array(z.string())),
        excludeCompleted: z.optional(booleanParamSchema),
      }),
      responses: {
        200: z.array(ZTicketDetails),
        404: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
  },
);
